import React, {useEffect, useState} from "react";
import {BookingFilters} from "../../hooks/useBookingMeSearchData";
import ButtonSearch from "../../../common/components/filters/ButtonSearch";
import BookingStatusFilter from "./BookingStatusFilter";
import ConfirmationNumberFilter from "../../../common/components/filters/ConfirmationNumberFilter";
import EventFilter from "../../../common/components/filters/EventFilter";
import CityFilter from "../../../common/components/filters/CityFilter";
import HotelFilter from "./HotelFilter";
import YearFilter from "../../../common/components/filters/YearFilter";

const BookingMeSearchForm = ({onSearch, loading, bookings}) => {
    const [query, setQuery] = useState<BookingFilters>({});
    const [bookingEvents, setBookingEvents] = useState<any[]>([]);
    const [bookingHotels, setBookingHotels] = useState<any[]>([]);
    const [bookingCities, setBookingCities] = useState<any[]>([]);
    const uniqueById = (arr: any[]) => Array.from(new Map(arr.map(item => [item, item])).values());

    useEffect(() => {
        if (!bookings || bookings.length === 0) return;
        if (bookingEvents.length > 0 || bookingHotels.length > 0 || bookingCities.length > 0) return;

        const allEvents = bookings.map(b => b.event);
        const allHotels = bookings.map(b => b.hotel.id);
        const allCities = bookings.map(b => b.city.id);

        setBookingEvents(uniqueById(allEvents));
        setBookingHotels(uniqueById(allHotels));
        setBookingCities(uniqueById(allCities));

    }, [bookings, bookingEvents, bookingHotels, bookingCities]);

    // Trigger initial search on mount
    useEffect(() => {
        onSearch(query);
    }, [onSearch]);

    // Handle input changes
    const onChange = (updates: Partial<BookingFilters>) => {
        setQuery((prev) => ({
            ...prev,
            ...updates
        }));
    };

    // Handle form submission
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSearch(query);
    };

    return (
        <form
            onSubmit={handleSubmit}
            className="
                w-full relative mt-8 flex flex-col lg:flex-row lg:items-center
                lg:rounded-full shadow-xl dark:shadow-2xl bg-white dark:bg-neutral-800 bg-opacity-95
                [&>*]:w-full              // 🔥 cada filtro ocupa el 100% del ancho en móvil
                lg:[&>*]:max-w-[240px]    // 🔥 en desktop vuelven a límite 240px
                lg:[&>*]:flex-1           // 🔥 distribución equitativa en desktop
            ">
            {/* Event Selector */}
            <EventFilter onChange={onChange} events={bookingEvents}/>
            {/* City Selector */}
            <CityFilter onChange={onChange} cities={bookingCities}/>
            {/* Hotel Selector */}
            <HotelFilter onChange={onChange} hotels={bookingHotels}/>
            {/* Confirmation Number Input */}
            <ConfirmationNumberFilter query={query} onChange={onChange}/>
            {/* Status Selector */}
            <BookingStatusFilter query={query} onChange={onChange}/>
            {/*/!* Payment Selector *!/*/}
            {/*<PaymentStatusFilter query={query} onChange={onChange}/>*/}
            {/*Year Selector*/}
            <YearFilter query={query} onChange={onChange}/>
            <div className="pl-2 lg:pl-0 pr-2 pb-4 lg:pb-0 xl:pr-4 w-full lg:w-auto flex justify-end lg:justify-center">
                <ButtonSearch type="submit"/>
            </div>
        </form>
    );
};

export default BookingMeSearchForm;
